// "(2) RedHosting" no titulo da aba: mensagens novas que chegaram enquanto a aba
// nao estava em foco. Zera quando a pessoa volta para a aba.
const PREFIX = /^\(\d+\)\s*/;
let unread = 0;

const baseTitle = () => document.title.replace(PREFIX, '');

const reset = () => {
  if (!unread) return;
  unread = 0;
  document.title = baseTitle();
};

export const bumpTitleCounter = () => {
  unread += 1;
  document.title = `(${unread}) ${baseTitle()}`;
};

window.addEventListener('focus', reset);
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) reset();
});
